export const formatTempo = (totalSeconds) => {
  const safeSeconds = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const seconds = safeSeconds % 60;

  return [hours, minutes, seconds]
    .map(part => String(part).padStart(2, '0'))
    .join(' : ');
};

export const formatPercentual = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return '-';

  return `${number.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
};

export const formatNumero = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number.toLocaleString('pt-BR') : '-';
};
